import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useDaily, useLocalSessionId, useWaitingParticipants } from '@daily-co/daily-react';
//Recoil系
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { useNavigate, useParams } from 'react-router-dom';
import {
  pageAtom,
  myNftAtom,
  sessionUsersAtom,
  myNftBackAtom,
  topMessageAtom,
  webcamAtom,
  myMuteAtom,
  userTypeAtom,
  BGMAtom,
  BGMVolumeAtom,
} from '../../State';
import { useTranslation } from 'react-i18next';
import NFT2 from '../NFT/NFT2';

//CSSやその他
import './Call.css';
import DataModel from '../Util/DataModel';
import Sound from '../Sound/Sound';
import isElectron from '../../Global';

//コンポーネント
import Avatar from '../Avatar/Avatar';
import NFT from '../NFT/NFT';
import NFTDetail from '../NFT/NFTDetail';
import RemoteAvatars from './RemoteAvatars';
import AutoplayDialog from './AutoplayDialog';
import ScreenSelect from './ScreenSelect';
import Live2dWrap from '../Live2d/Live2dWrap';
import AddAccess from '../Util/AddAccess';
import Record from './Record';
import NFTBack from '../NFT/NFTBack';

export default function Call({ roomID, userType, isRecord = false, preAuthCompleteState }) {
  const urlParam = useParams();
  var roomID = urlParam.id; //URL取得
  let showThisNFT = roomID == 'makopt' || roomID == '144987874' ? true : false;

  //Daily系
  const callObject = useDaily();
  const localSessionID = useLocalSessionId();
  const { waitingParticipants, grantAccess } = useWaitingParticipants();
  const { t } = useTranslation();

  //Recoil系
  const pageState = useRecoilValue(pageAtom);
  const setSessionUsers = useSetRecoilState(sessionUsersAtom);
  const myNftState = useRecoilValue(myNftAtom);
  const [myNftBackState, setMyNftBackState] = useRecoilState(myNftBackAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [BGMState, setBGMState] = useRecoilState(BGMAtom);
  const [BGMVolumeState, setBGMVolumeState] = useRecoilState(BGMVolumeAtom);
  const webcamState = useRecoilValue(webcamAtom);
  const myMuteState = useRecoilValue(myMuteAtom);
  const userTypeState = useRecoilValue(userTypeAtom);

  const unsubRef = useRef(null); //リスナーを止める用

  //初期化
  const init = async (e) => {
    if (isRecord == false) {
      //参加成功のお知らせ
      setTopMessageState({
        type: 'joined',
        message: t('top.You joined the call'),
      });
    }

    //録画スタート
    //startRecord();

    //セッションIDを取得
    if (callObject == null) return;
    callObject
      .getMeetingSession()
      .then(async (session) => {
        //自分の情報をseessionに登録

        // const localUserData = callObject.participants()['local'].userData;
        // callObject.setUserData({ ...localUserData, audioURL: 'https' });

        // setTimeout(() => {
        //   const localUserData2 = callObject.participants()['local'].userData;
        //   console.log('ユーザーデーあ');
        //   console.log(localUserData2);
        // }, 2000);

        let nftWhoCanUse = localStorage.getItem('nftWhoCanUse') ?? 'anyone';

        try {
          await DataModel.saveSessionToRoom(
            roomID, //ルームID
            session.meetingSession.id, //ルームのセッションID
            localSessionID, //ユーザーのテンポラリーユーザーID
            myNftState, //顔
            myNftBackState, //背景
            webcamState, //顔認識
            null, //録画
            myMuteState, //ミュート状態
            nftWhoCanUse, //NFTが誰が使えるか
            userType, //ユーザータイプ
            BGMState, //BGM
            BGMVolumeState, //BGMVolume
          );

          console.log('セッション保存完了');
        } catch (error) {
          console.log(error);
        }

        try {
          //他の参加者の情報取得
          unsubRef.current = await DataModel.selectSessionData(
            session.meetingSession.id,
            setSessionUsers,
            setMyNftBackState,
            setBGMState,
            setBGMVolumeState,
          );
          //アクセス
          AddAccess('page-view', 'call', null, roomID, localSessionID);
        } catch (error) {
          console.log(error);
        }
      })
      .catch((error) => {
        //console.log(error);
      });
  };

  //待機中のユーザーに対しての処理
  useEffect(() => {
    if (waitingParticipants.length > 0) {
      //許可を与える
      grantAccess('*');
    }
  }, [waitingParticipants]);

  //録画スタート
  async function startRecord() {
    // axios.get('https://geolocation-db.com/json/').then((response) => {
    //   console.log('ここきたよ');
    //   console.log(response.data);
    // });

    if (window.location.hostname == 'localhost') {
      return;
    }

    //ヘッダー
    //   const options = {
    //     method: 'GET',
    //     headers: {
    //       Accept: 'application/json',
    //     },
    //   };

    //   //Braveだとエラーになる(広告ブロッカーが邪魔をする)
    //   fetch('https://geolocation-db.com/json/', options)
    //     .then((response) => response.json())
    //     .then((data) => {
    //       if (data.IPv4 != '122.211.82.251') {
    //         callObject.startRecording();
    //       }
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
  }

  //読み込み時初回処理
  useEffect(() => {
    //初期化
    init();
    //リスナーをはずす
    return () => unsubRef.current;
  }, []);

  //レンダービュー
  return (
    <>
      {/* スクリーン画像選択　*/}
      {isElectron && pageState == 'selectScreen' && <ScreenSelect />}

      {/* モバイル用Autoplaydialog */}
      <AutoplayDialog userType={userType} />

      {/* 録画用 */}
      {isRecord && <Record preAuthCompleteState={preAuthCompleteState} />}

      {/* 効果音　*/}
      <Sound />
      {/* NFTリスト　*/}
      {pageState == 'nftList' && <>{showThisNFT ? <NFT2 /> : <NFT />}</>}
      {/*NFT詳細画面*/}
      {pageState == 'nftDetail' && <NFTDetail />}
      {/*背景*/}
      {pageState == 'background' && <NFTBack />}

      {/* スクリーンシェアのときに全画面キャプチャーの場合　*/}
      {/* {screenShareState != null && screenShareState.isWholeScreen && (
        <div id="screenWholeScreen">Sharing Whole Screen</div>
      )} */}
    </>
  );
}
